import type { ProductInformation } from "../PersistentCartPaymentOptions/PersistentCartPaymentOptions";
import { PriceSummary } from "../PriceSummary";
import { currencyFormatter } from "../UtilsHelper";
import {
  monthlyPayments,
  upfrontPaymentsTotal,
} from "../helpers/PersistentPaymentSummaryHelper";

interface CartPriceModel {
  productsInformation: ProductInformation[];
  currency: string;
  totalPaymentAmount: number;
}
interface PersistentCartPriceSummaryProps {
  cartPriceModel: CartPriceModel;
}
export function PersistentCartPriceSummary({
  cartPriceModel,
}: PersistentCartPriceSummaryProps) {
  const { productsInformation, currency, totalPaymentAmount } = cartPriceModel;
  const priceModel = {
    downpaymentAmount: upfrontPaymentsTotal(productsInformation, currency),
    installmentCounts: monthlyPayments(productsInformation, currency),
    annualPaymentAmount: currencyFormatter(currency).format(totalPaymentAmount),
  };
  return (
    <div className="mobius-payment-summary__persistent-price-summary">
      <PriceSummary priceModel={priceModel} />
    </div>
  );
}
